<template>
  <b-modal id="modal-pago" title="Finalizar Cobro" size="lg" @show="resetModal" hide-footer no-stacking>
    <b-container fluid>
      <b-card bg-variant="light" border-variant="primary" class="mb-3 shadow-sm text-center">
        <b-row align-v="center">
          <b-col>
            <span class="text-muted small text-uppercase">Subtotal Venta</span><br>
            <span class="h5">${{ totalVenta | currency }}</span>
          </b-col>
          <b-col v-if="pagoTarjeta > 0">
            <span class="text-danger small text-uppercase">Comisión MP (3.5% + IVA)</span><br>
            <span class="h5 text-danger">+ ${{ infoComision.totalExtra | currency }}</span>
          </b-col>
          <b-col>
            <span class="text-primary font-weight-bold small text-uppercase">TOTAL A COBRAR</span><br>
            <span class="h3 font-weight-bold text-primary">${{ totalFinalCalculado | currency }}</span>
          </b-col>
        </b-row>
      </b-card>

      <b-form>
        <b-row>
          <b-col md="4">
            <b-form-group label="Efectivo:">
              <b-input-group prepend="$">
                <b-form-input
                  v-model.number="pagoEfectivo"
                  type="number"
                  @focus="$event.target.select()"
                  placeholder="0.00"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Tarjeta (Neto):" label-class="font-weight-bold text-info">
              <b-input-group prepend="$">
                <b-form-input
                  v-model.number="pagoTarjeta"
                  type="number"
                  class="border-info"
                  @focus="$event.target.select()"
                  placeholder="0.00"
                ></b-form-input>
              </b-input-group>
              <small class="text-info" v-if="pagoTarjeta > 0">
                Cobrar en Terminal: <strong>${{ infoComision.montoTerminal | currency }}</strong>
              </small>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Transferencia / Resto:">
              <b-input-group prepend="$">
                <b-form-input
                  :value="pagoTransferencia.toFixed(2)"
                  readonly
                  class="bg-white font-weight-bold"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-2">
          <b-alert v-if="cambio > 0" show variant="success" class="text-center h4">
            Cambio en efectivo: ${{ cambio | currency }}
          </b-alert>
        </div>

        <div class="d-flex justify-content-between mt-4 border-top pt-3">
          <b-button variant="outline-secondary" @click="$bvModal.hide('modal-pago')">
            Cancelar
          </b-button>
          <b-button
            variant="success"
            size="lg"
            @click="confirmar"
            class="px-5 font-weight-bold"
          >
            CONFIRMAR VENTA
          </b-button>
        </div>
      </b-form>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  props: {
    totalVenta: { type: Number, default: 0 }
  },
  data () {
    return {
      pagoEfectivo: 0,
      pagoTarjeta: 0,
      factor: 0.9594 // Representa 1 - (0.035 * 1.16)
    }
  },
  watch: {
    // Seguridad: Impide que la tarjeta exceda el total de la venta
    pagoTarjeta (nuevo) {
      if (nuevo > this.totalVenta) {
        this.pagoTarjeta = this.totalVenta
      } else if (nuevo < 0 || !nuevo) {
        this.pagoTarjeta = 0
      }
    },
    // Limpieza de valores negativos en efectivo
    pagoEfectivo (nuevo) {
      if (nuevo < 0 || !nuevo) {
        this.pagoEfectivo = 0
      }
    }
  },
  computed: {
    infoComision () {
      if (this.pagoTarjeta <= 0) return { totalExtra: 0, montoTerminal: 0 }
      const montoTerminal = this.pagoTarjeta / this.factor
      return {
        totalExtra: montoTerminal - this.pagoTarjeta,
        montoTerminal: montoTerminal
      }
    },

    pagoTransferencia () {
      // El resto se calcula sobre el valor neto (sin comisiones)
      const netoPagadoManual = Number(this.pagoEfectivo) + Number(this.pagoTarjeta)
      const diferencia = this.totalVenta - netoPagadoManual
      return diferencia > 0 ? diferencia : 0
    },

    totalFinalCalculado () {
      return this.totalVenta + this.infoComision.totalExtra
    },

    cambio () {
      const netoPagadoManual = Number(this.pagoEfectivo) + Number(this.pagoTarjeta)
      return netoPagadoManual > this.totalVenta ? (netoPagadoManual - this.totalVenta) : 0
    }
  },
  methods: {
    resetModal () {
      this.pagoEfectivo = 0
      this.pagoTarjeta = 0
    },
    // Formateador para el cuadro de confirmación
    fmt (val) {
      return parseFloat(val || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    async confirmar () {
      // Creamos el contenedor del mensaje usando $createElement para que BootstrapVue lo entienda
      const h = this.$createElement

      // Construimos el contenido HTML
      const mensajeVNode = h('div', { class: ['text-left'] }, [
        h('p', { class: ['mb-1'] }, ['Subtotal Venta: ', h('b', `$${this.fmt(this.totalVenta)}`)]),
        this.pagoTarjeta > 0 ? h('p', { class: ['mb-1', 'text-danger'] }, [
          'Comisión Tarjeta: ', h('b', `+$${this.fmt(this.infoComision.totalExtra)}`)
        ]) : '',
        h('hr'),
        h('h4', { class: ['text-center', 'text-primary', 'mb-3', 'font-weight-bold'] }, `Total: $${this.fmt(this.totalFinalCalculado)}`),
        h('div', { class: ['bg-light', 'p-3', 'border', 'rounded'] }, [
          h('p', { class: ['mb-1'] }, ['Efectivo: ', h('b', `$${this.fmt(this.pagoEfectivo - this.cambio)}`)]),
          h('p', { class: ['mb-1'] }, ['Tarjeta (Terminal): ', h('b', `$${this.fmt(this.infoComision.montoTerminal)}`)]),
          h('p', { class: ['mb-0', this.pagoTransferencia > 0 ? 'text-primary' : ''] }, [
            'Transferencia: ', h('b', `$${this.fmt(this.pagoTransferencia)}`)
          ])
        ]),
        this.cambio > 0 ? h('div', { class: ['alert', 'alert-success', 'mt-3', 'mb-0', 'py-2'] }, [
          h('small', [h('b', 'AVISO: '), 'Cambio ', h('b', `$${this.fmt(this.cambio)}`)])
        ]) : '',
        this.pagoTransferencia > 0 ? h('div', { class: ['alert', 'alert-warning', 'mt-3', 'mb-0', 'py-2'] }, [
          h('small', [h('b', 'AVISO: '), 'Verifique la transferencia de ', h('b', `$${this.fmt(this.pagoTransferencia)}`)])
        ]) : ''
      ])

      // Llamamos al modal pasando el VNode como el primer argumento
      const confirm = await this.$bvModal.msgBoxConfirm([mensajeVNode], {
        title: 'Confirmar recepción de pago',
        okTitle: 'SÍ, COBRADO',
        cancelTitle: 'CORREGIR',
        okVariant: 'success',
        cancelVariant: 'outline-secondary',
        centered: true,
        size: 'md',
        buttonSize: 'lg'
      })

      if (confirm) {
        const payload = {
          venta_neta: this.totalVenta,
          comision_extra: this.infoComision.totalExtra,
          total_final: this.totalFinalCalculado,
          // Guardamos el cambio para el registro contable
          cambio_entregado: this.cambio,
          pagos: {
            // El efectivo_recibido es lo que el cliente puso en la mesa
            efectivo_recibido: this.pagoEfectivo,
            // El efectivo_neto es lo que realmente se queda en caja
            efectivo_neto: this.pagoEfectivo - this.cambio,
            cambio: this.cambio,
            transferencia: this.pagoTransferencia,
            tarjeta_terminal: this.infoComision.montoTerminal
          }
        }

        // Si hubo cambio, podemos lanzar una pequeña notificación extra o
        // simplemente enviarlo en el evento confirmado
        this.$emit('confirmado', payload)
        this.$bvModal.hide('modal-pago')

        // Opcional: Una alerta simple si hubo cambio, para que no se le olvide al cajero
        if (this.cambio > 0) {
          this.$bvToast.toast(`Entregar cambio de $${this.fmt(this.cambio)}`, {
            title: 'Recordatorio de Cambio',
            variant: 'success',
            solid: true
          })
        }
      }
    }
  },
  filters: {
    currency (val) {
      return parseFloat(val || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>
